import { Icon } from '@aon/aon-tws-common-ui';
import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import * as React from 'react';
import styled from 'styled-components';

export interface ICounterDisplayToggleProps {
	count: number;
	open: boolean;
	onClick: (id: number) => void;
	id: number;
}

export const CounterDisplayContainer = styled.div<{ count: number; isActive: boolean }>`
	cursor: ${(props) => (props.count > 0 ? 'pointer' : 'default')};
	display: inline-block;
	padding: 5px 8px;

	${(props) =>
		props.isActive
			? `
		background-color: ${globalVars.mainBlue};
		border-radius: 5px;
		color: #FFF;
		`
			: ''}

	span {
		margin-left: 2px;
		.tws-i-icon {
			bottom: 1px;
			font-size: 9px !important;
			position: relative;
		}
	}
`;

export const ToggleSpan = styled.span`
	vertical-align: top;
`;

export class CounterDisplayWithToggle extends React.Component<ICounterDisplayToggleProps> {
	constructor(props: ICounterDisplayToggleProps) {
		super(props);

		this.HandleOnClick = this.HandleOnClick.bind(this);
	}

	public render() {
		const displayCount: string = this.props.count === 0 ? '--' : this.props.count.toString();
		return (
			<CounterDisplayContainer count={this.props.count} isActive={this.props.open && this.props.count > 0} onClick={this.HandleOnClick}>
				{displayCount}
				{this.GetDrawerToggle()}
			</CounterDisplayContainer>
		);
	}

	public GetDrawerToggle() {
		if (this.props.count < 1) {
			return null;
		}
		return this.GetDirectionalArrow();
	}

	public GetDirectionalArrow() {
		return (
			<ToggleSpan>
				<Icon name={this.props.open ? 'angle-up' : 'angle-down'} />
			</ToggleSpan>
		);
	}

	public HandleOnClick() {
		if (this.props.count > 0) {
			this.props.onClick(this.props.id);
		}
	}
}
